export default __webpack_public_path__ + "static/media/avatar1.d193b340.svg";